import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#F9F6F0] to-[#F1EBE0] text-[#5D4E37] py-16 relative overflow-hidden border-t border-[#EBE6DD]">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-[1.5px] bg-gradient-to-r from-transparent via-[#D97706]/30 to-transparent"></div>
      
      {/* Faint decorative Om symbols in the background */}
      <div className="absolute top-6 left-8 text-8xl text-[#D97706] opacity-[0.05] select-none pointer-events-none font-serif">ॐ</div>
      <div className="absolute bottom-6 right-8 text-8xl text-[#D97706] opacity-[0.05] select-none pointer-events-none font-serif">ॐ</div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-left">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img
                src="/logo.jpg"
                alt="Vastuspace.AI logo"
                className="w-10 h-10 object-contain rounded-full border border-[#826239]/30 shadow-sm"
              />
              <h3 className="text-xl font-bold tracking-tight text-[#352520]">
                Vastuspace.AI
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[#826239] font-light">
              AI-powered Vastu analysis for modern living spaces. Bringing ancient wisdom to contemporary architecture.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-[#352520] text-xs uppercase tracking-widest mb-5">Quick Links</h4>
            <ul className="space-y-3.5 text-sm text-[#5D4E37]">
              <li>
                <Link to="/about" className="hover:text-[#D97706] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/professionals" className="hover:text-[#D97706] transition-colors">
                  For Professionals
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#D97706] transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-[#D97706] transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-[#352520] text-xs uppercase tracking-widest mb-5">Services</h4>
            <ul className="space-y-3.5 text-sm text-[#5D4E37]">
              <li>
                <Link to="/upload" className="hover:text-[#D97706] transition-colors">
                  Floor Plan Analysis
                </Link>
              </li>
              <li>
                <Link to="/consultants" className="hover:text-[#D97706] transition-colors">
                  Expert Consultants
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="hover:text-[#D97706] transition-colors">
                  Remedy Marketplace
                </Link>
              </li>
              <li>
                <Link to="/ai-assistant" className="hover:text-[#D97706] transition-colors">
                  AI Assistant
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-[#352520] text-xs uppercase tracking-widest mb-5">Contact</h4>
            <ul className="space-y-4 text-sm text-[#5D4E37]">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                <span className="hover:text-[#D97706] transition-colors">support@vastuai.com</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                <span className="hover:text-[#D97706] transition-colors">+91 98765 43210</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#D97706] flex-shrink-0" />
                <span className="hover:text-[#D97706] transition-colors">Mumbai, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#826239]/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#826239]/80 font-light">
            © 2025 Vastuspace.AI. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-[#826239]/80">
            <Link to="/terms" className="hover:text-[#D97706] transition-colors">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-[#D97706] transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
